import React, { useEffect, useState } from 'react';
import { clickable } from "../../utils/a11y";
import axios from 'axios';
import "../../styles/Doctor-ui/Doctor-appointment/DA-orders.css";
import Popup from 'reactjs-popup';
import { useForm } from "react-hook-form";
import { toast } from '../../utils/toast';
import { useSubmitGuard } from '../../utils/useSubmitGuard';
import { errorMessage } from '../../utils/errorMessage';
import Loader from '../../utils/loader';
import { API_DETAILS } from '../../App';
import { COOKIE_KEYS } from "../../App";
import Cookies from "js-cookie";
import { REFILL_OPTION } from '../../utils/refillOrder';

const Orders = (props) => {

 
  const [selectedOption, setSelectedOption] = useState(props.diag);
  const [diagnosisNames, setDiagnoses] = useState([]);
  const [carePlan, setCarePlan] = useState([]);
  const [carePlanDetails, setCarePlanDetails] = useState({}); // []
  const [refillId, setRefillId] = useState();
  const [editCarePlan, setEditCarePlan] = useState(false);
  //const [showItems, setShowItems] = useState(['vitamins', 'medicines', 'lifeStyle']);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [saving, guard] = useSubmitGuard();
  const [careplanVersion, setCareplanVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState('');
  const [notes, setNotes] = useState('');
  const [followUp, setFollowUp] = useState(null);
  const [followUpDate, setFollowUpDate] = useState('');
  const [warningMessage, setWarningMessage] = useState('');
  const [dosageMessage, setDosageMessage] = useState('');

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  

  useEffect(() => {
    fetchAllDiagnoses();
  if (!Object.keys(props.ordersData).length > 0) {
    fetchVersions();
    if(props.diag){
      fetchMedicines(props.diag)
    }
  } else if (props.ordersData) {
    setEditCarePlan(true)
    props.setCarePlanView(false)
    const { refillId, ...ordersData } = props.ordersData;
    setCarePlanDetails(ordersData);
    setRefillId(refillId);
  }

  }, [])

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.includes('e') || value.includes('.') || !/^\d*$/.test(value)) {
      e.target.value = '';
    }
  };

  // An order is a refill because it answers a refill request, which is what
  // refillId is. Nothing else about it — the diagnosis in particular — says so.
  const isRefill = Boolean(refillId);

  const handleReject = guard(() => {
    const url = `${API_DETAILS.baseUrl}${API_DETAILS.PORT}/youro/api/v1/rejectRefill/${refillId}`;

    setIsLoading(true);
    return axios.post(url).then(res => {
      toast.success("Refill request rejected.")
    }).catch(err => {
      toast.error(errorMessage(err, "We couldn't reject that refill request. Refresh and try again."));
    }).finally(() => {
      setIsLoading(false);
      setOpen(false);
      props.closePopup(false);
      props.nav();

      if (props.onRefillChange) {
        props.onRefillChange();
      }
    });
  });

  // The quantity and refill boxes shown in the popup: one pair per ticked
  // medication. Read from state, not from the page — this used to validate every
  // element with class "input-field" anywhere on screen, so an unrelated empty
  // field elsewhere blocked the order and focused a box the provider could not
  // see.
  const orderedMedications = () =>
    Object.values(carePlanDetails.presTypes || {})
      .flat()
      .filter((prescription) => prescription.indicator && prescription.medication);

  const isWholeNumber = (value) =>
    value !== undefined && value !== null && value !== '' && Number.isInteger(Number(value)) && Number(value) >= 0;

  const handleSubmitDosage = guard(async () => {
    const url = `${API_DETAILS.baseUrl}${API_DETAILS.PORT}/youro/api/v1/saveCarePlanDetails`;

    const missing = orderedMedications().find(
      (prescription) => !isWholeNumber(prescription.dosage) || !isWholeNumber(prescription.refillCount)
    );
    if (missing) {
      setDosageMessage(`Enter a whole number for both the quantity and the refills of ${missing.presName}.`);
      return;
    }
    setDosageMessage('');

    const filteredPrescriptions = {};
    if (carePlanDetails.presTypes) {
      Object.entries(carePlanDetails.presTypes).forEach(([typeId, prescriptions]) => {
        const filtered = prescriptions.filter(prescription => prescription.indicator);
        if (filtered.length > 0) {
          filteredPrescriptions[typeId] = filtered;
        }
      });
    }

    const data = {
      carePlanDetails: {presTypes: filteredPrescriptions},
      apptId: props.apptId,
      // A refill has no diagnosis of its own: the server attaches it to the
      // appointment's, and recognises it by refillId.
      diagID: isRefill ? 0 : selectedOption,
      refillId: refillId,
      notes: notes,
      doctorId: Cookies.get(COOKIE_KEYS.userId),
      followUp: followUp,
      followUpDate: followUpDate
    };

    setIsLoading(true);
    try {
      await axios.post(url, data);
    } catch (err) {
      // The popup used to close, and the page navigate away, before this answer
      // came back, so a failed order vanished with everything the provider had
      // typed. It now stays open, with what they entered, and says why.
      setIsLoading(false);
      setDosageMessage(errorMessage(err, "This order wasn't saved. Your entries are still here, so check them and submit again."));
      props.handleToast(false);
      return;
    }
    setIsLoading(false);
    props.handleToast(true);
    if (props.onRefillChange) {
      props.onRefillChange();
    }
    setOpen(false);
    props.closePopup(false);
    props.nav();
  });


  const fetchAllDiagnoses = async () => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + `/youro/api/v1/getAllDiagnoses`;
    try {
      const res = await axios.get(url);
      setDiagnoses(res.data);
    }
    catch (err) {
    }
  };

  const fetchVersions = async () => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + `/youro/api/v1/getCarePlanVersions/${props.apptId}`;
    try {
      const res = await axios.get(url);
      if(res.data && res.data.length){
        setCareplanVersions(res.data);
        setSelectedVersion(res.data[0].cId);
        getCarePlanDetails(res.data[0].cId, false);//false
      }else{
        setEditCarePlan(true) //true
        props.setCarePlanView(false)
      }
    }
    catch (err) {
    }
  };

  const getCarePlanDetails = async (cId, edit) => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + `/youro/api/v1/getCarePlanDetails/${cId}?edit=${edit}`;
    setIsLoading(true);
    try {
      const res = await axios.get(url);
      if (!edit) {
        setCarePlan(res.data);
      }
      if (edit) {
        setCarePlanDetails(res.data.carePlan); 
        //console.log("diagnosisNames: ", diagnosisNames);
        //console.log("inside edit", diagnosisNames.filter(val => val.name == res.data.diagName)[0].diagId);
        // Matched by name because that is what this response carries. It used to
        // take [0] of the match unconditionally, which crashed the edit view when
        // the list had not loaded yet or the name had since changed.
        const match = diagnosisNames.find(val => val.name === res.data.diagName);
        if (match) setSelectedOption(match.diagId);
        //setSelectedOption(res.data.diagId);
        setNotes(res.data.notes); 
        setFollowUp(res.data.followUp);
        setFollowUpDate(res.data.followUpDate);
      }
    }
    catch (err) {
    } finally {
      setIsLoading(false);
    }
  }


  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    fetchMedicines(event.target.value);
  };


  const fetchMedicines = async(diagId) => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + `/youro/api/v1/getCarePlanDetailsById/${diagId}`;
    try {
      setIsLoading(true)
      const res = await axios.get(url);
      setIsLoading(false);
      setCarePlanDetails(res.data);
      setNotes(res.data.notes)
    }
    catch (err) {
      setIsLoading(false);
    }
  }


  const handleCheckboxChange = (i, presType) => {
    // Assuming carePlanDetails is structured with presTypes nested within an array at the first index
    let dupUserRes = { ...carePlanDetails }; // Create a shallow copy of the carePlanDetails object
    
    // Dynamically find the right prescription type array and update the indicator for the matched prescription ID
    if(dupUserRes.presTypes && dupUserRes.presTypes[presType]) {
      dupUserRes.presTypes[presType] = dupUserRes.presTypes[presType].map(item =>
        // add log here to see if the item is being updated
        item.presId === i.presId ? { ...item, indicator: !item.indicator } : item
      );
    }
  
    // Update state with the modified object
    setCarePlanDetails(dupUserRes);
  };
  

  const handleDosage = (presType, prescription, value) => {
    // Assuming carePlanDetails is structured with presTypes
    const numericValue = value ? parseInt(value, 10) : 0;
    let dupCarePlanDetails = { ...carePlanDetails }; // Create a shallow copy of the carePlanDetails object
    
    // Dynamically find the right prescription type array and update the dosage for the matched prescription ID
    if(dupCarePlanDetails.presTypes && dupCarePlanDetails.presTypes[presType]) {
      dupCarePlanDetails.presTypes[presType] = dupCarePlanDetails.presTypes[presType].map(item =>
        item.presId === prescription.presId ? { ...item, dosage: numericValue } : item
      );
    }
  
    // Update state with the modified object
    setCarePlanDetails(dupCarePlanDetails);
  };

  const handleRefillChange = (presType, prescription, value) => {
    // Convert input value to a number, defaulting to 0 if empty
    const numericValue = value ? parseInt(value, 10) : 0;

    // Create a shallow copy of the carePlanDetails object
    let dupCarePlanDetails = { ...carePlanDetails };

    // Navigate to the correct prescription type and map through the array
    if (dupCarePlanDetails.presTypes && dupCarePlanDetails.presTypes[presType]) {
      dupCarePlanDetails.presTypes[presType] = dupCarePlanDetails.presTypes[presType].map(item =>
        // Check for matching presId and update the refill count
        item.presId === prescription.presId
          ? { ...item, refillCount: numericValue }
          : item
      );
    }

    // Log and update state
    setCarePlanDetails(dupCarePlanDetails);
  }


  const handleFollowUpChange = (e) => {
    const isFollowUp = e.target.checked;
    setFollowUp(isFollowUp);
    if (!isFollowUp) {
      setWarningMessage('');
    }
  };

  const handleSub = () => {
    if (followUp && !followUpDate) {
      setWarningMessage('Please choose a follow-up date');
    } else {
      setWarningMessage('');
      setOpen(true);
    }
  }

  const handleSelectVersionChange = (e) => {
    setSelectedVersion(e.target.value);
    getCarePlanDetails(e.target.value, false)
  }

  const handleEdit = () => {
    setEditCarePlan(true);
    getCarePlanDetails(selectedVersion, true)
    props.setCarePlanView(false)
    // fecthMedicinesV2()
  }


  return (
    <div>
      {!editCarePlan && carePlan && carePlan['carePlan'] && <div style={{overflow: 'auto', height: '80vh', width: '500px'}}>
      <select id="s" name="s" style={{marginLeft: '0px'}} className='dropdown-chart' value={selectedVersion} onChange={handleSelectVersionChange}>
        {
          careplanVersion.map((result) => (<option value={result.cId}>{result.version}</option>))
        }
      </select>


      {Object.keys(carePlan['carePlan'].presTypes).map(presTypeKey => {
        const itemsByPresType = carePlan['carePlan'].presTypes[presTypeKey];

        // Group items by categoryName
        const categories = itemsByPresType.reduce((acc, item) => {
          if (item.indicator) {
            if (!acc[item.categoryName]) {
              acc[item.categoryName] = {
                items: [],
                typeName: item.type.name,
              };
            }
            acc[item.categoryName].items.push(item);
          }
          return acc;
        }, {});

        return Object.entries(categories).map(([categoryName, { items, typeName }]) => (
          <div key={presTypeKey + categoryName}>
            <h4 style={{margin: '15px 0px'}}>{typeName}</h4>
            {items[0].categoryName !== null && <h5 style={{margin: '0px 10px'}}>{items[0].categoryName}</h5>}
            <ul style={{margin: '0px'}}>
              {items.map(item => (
                <li key={item.presId}>
                  {item.presName}{item.dosage ? ` - ${item.dosage}` : ''}
                </li>
              ))}
            </ul>
          </div>
        ));
      })} <br /><br />


      {carePlan.followUp ? <div style={{display: 'flex', alignItems: 'center'}}><span className="material-symbols-outlined">
                            sync
                            </span><strong>&nbsp;&nbsp;Follow-up required</strong></div> :
                             <div style={{display: 'flex', alignItems: 'center'}}><span className="material-symbols-outlined">
                             select_check_box
                             </span><strong>&nbsp;&nbsp;Follow-up not required</strong></div>} <br /> <br />
      <strong>Notes : </strong><p style={{wordWrap: 'break-word'}}>{carePlan.notes}</p> <br /><br /><br />
      {careplanVersion.filter(val => val.cId == selectedVersion && val.edit)[0] && <div className='btn-filled' onClick={() => handleEdit()}>Edit</div>}</div>}

      {editCarePlan && <div className='order-div'>

<div className='orders-row'>
  <div className='dropdown-list' style={{width: 'fit-content'}}>

 <select id="d" name="d" className='dropdown-chart' style={{marginLeft: '0px'}} value={selectedOption} onChange={handleSelectChange}>
  <option>Select Diagnosis</option>
  {/* Offered only when this order answers a refill request. */}
  {isRefill && <option value={REFILL_OPTION}>Refill</option>}
  {
    diagnosisNames.map((result) => (<option key={result.diagId} value={result.diagId}>{result.name}</option>))
  }
</select>
</div>

  {/* {selectedOption && <> {carePlanDetails && carePlanDetails[0] && Object.keys(carePlanDetails[0]).slice(0, 3).map((title) =>  <>
      <button className={showItems.includes(title) ? 'btn-outlined-selected' : 'btn-outlined'} onClick={() => handleItemSelection(title)}>{title}</button></>
  )}
    
  </>} */}

  
</div>

{selectedOption && <>

<></>


<div className="orders-checklist" style={{overflowX: 'auto', overflowY: 'auto', maxHeight: '80vh', padding: '20px' }}>
  <div className='orders-container' style={{ display: 'flex', minWidth: 'max-content', gap: '20px', backgroundColor: '#f9f9f9', padding: '20px', paddingRight: '20px', borderRadius: '8px' }}>
    {carePlanDetails.presTypes && Object.keys(carePlanDetails.presTypes).map((typeKey) => (
      <div key={typeKey} className="orders-name" style={{minWidth: '250px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <p className='order-label' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.2rem', color: '#333', borderBottom: '2px solid #eee', paddingBottom: '5px'}}>{carePlanDetails.presTypes[typeKey][0].type.name}</p>
        <div className="orders-list" style={{ overflowY: 'auto', maxHeight: '60vh'}}>
        {/* Group by category */}
        {Object.values(carePlanDetails.presTypes[typeKey].reduce((acc, item) => {
          const categoryName = item.category !== null ? item.category.name : ''; // Handle null category name
          if (!acc[categoryName]) {
            acc[categoryName] = [];
          }
          acc[categoryName].push(item);
          return acc;
        }, {})).map((categoryItems, index) => (
          <div key={index} style={{ display: 'flex', flexDirection: 'column' }}>
            {categoryItems[0].category!== null && (<p style={{ paddingLeft: '10px', fontWeight: 'bold', fontSize: '1rem', color: '#666' }}>{categoryItems[0].category.name}</p>)}
            {categoryItems.map(item => (
              <div
                key={item.presId}
                style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: (categoryItems[0].category === null) ? '10px' : '40px', paddingTop: (categoryItems[0].category === null) ? '10px' : '0px', paddingBottom: (categoryItems[0].category === null) ? '10px' : '0px' }}
              >
                <input
                  type="checkbox"
                  id={`item-${item.presId}`}
                  checked={item.indicator}
                  onChange={() => handleCheckboxChange(item, item.type.presTypeId)}
                  style={{ cursor: 'pointer' }}
                />
                <label htmlFor={`item-${item.presId}`}
                  style={{ fontSize: '0.9rem', color: '#555', fontStyle: 'italic', cursor: 'pointer', whiteSpace: 'normal', display: 'inline-block', maxWidth: '80%', overflowWrap: 'break-word' }}>{item.presName}</label>
              </div>
            ))}
          </div>
        ))}
        </div>
      </div>
    ))}
  </div>
</div>


<div style={{width: '95%', margin: '0px auto'}}>
<textarea style={{width: '100%', height: '50px'}} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder='Enter your notes here...'></textarea>
</div>
<br />
<div className = "ofr">
<input id='followUp' checked={followUp ? true : false} onChange={handleFollowUpChange} type='checkbox'></input>
<label htmlFor='followUp'>Follow-up required</label>
</div>

{followUp && (
    <div>
      <label style={{ paddingRight: '5px'}} htmlFor="followUpDate">Select follow-up date: </label>
      <input
        style={{ borderRadius: '8px', padding: '5px', border: '1px solid #ccc' }}
        type="date"
        id="followUpDate"
        value={followUpDate}
        onChange={(e) => setFollowUpDate(e.target.value)}
      />
    </div>
)}
{warningMessage && <p style={{ color: 'red' }}>{warningMessage}</p>}

<div className='submit-button'>
{isRefill && <button className='btn-filled' onClick={handleReject} disabled={saving} aria-busy={saving} style={{padding: '10px 15px', marginRight: '10px'}}>Reject Order</button>}
<button className='btn-filled ' onClick={handleSub} style={{padding: '10px 15px'}}>Submit order</button>
</div>
</>}

{!selectedOption && <>
<div style={{ width: '100%', height: '80%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <h3><i>Please select a diagnosis to complete order</i></h3>
            </div>
</>}


<Popup open={open} modal closeOnDocumentClick={false} onClose={() => setOpen(false)} className="congrats-popup">
    <div style={{ position: 'absolute', top: '20px', right: '20px', cursor: 'pointer' }} {...clickable(() => setOpen(false), 'Close')}>
        <span className="material-symbols-outlined">close</span>
    </div>

    <h1 style={{color: 'black', padding: '20px'}}>Dosage Instructions & Notes</h1>

    <div style={{padding: '0px 20px 20px 20px'}} className='popup-height'>
        {carePlanDetails.presTypes && Object.entries(carePlanDetails.presTypes).map(([typeId, prescriptions]) => {
            const presType = prescriptions[0]?.type?.name;
            const hasIndicator = prescriptions.some(prescription => prescription.indicator);
            const hasMedicine = prescriptions.some(prescription => prescription.medication);

            return hasIndicator && hasMedicine && (
                <>
                    <h3>{presType}</h3>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', rowGap: '10px'}}>
                        {prescriptions.map((prescription, i) => prescription.indicator && prescription.medication && (
                            <div key={prescription.presId || i} style={{
                                     display: 'flex',
                                     flexDirection: 'row',
                                     justifyContent: 'space-between',
                                     alignItems: 'flex-end',
                                     flexWrap: 'wrap',
                                     gap: '10px',
                                     width: '100%'
                                 }}>
                              <div style={{width: '45%'}}>
                                  {/* "Quantity", not "Dosage": this is how many to
                                      dispense. The dose itself is part of the
                                      prescription name, e.g. "Tamsulosin 0.4mg qd". */}
                                  <label>{prescription.presName} Quantity :</label>
                                  <input
                                      className="input-field input-border"
                                      type="number"
                                      value={/* ?? not ||, so a typed 0 survives */ prescription.dosage ?? ''}
                                      onChange={(e) => handleDosage(prescription.type.presTypeId, prescription, e.target.value)} //presType.toLowerCase()
                                      placeholder="Enter Quantity..."
                                      style={{ width: '100%' }}
                                      onInput={(e) => handleInputChange(e)}
                                      min="0"
                                      step="1"
                                  />
                              </div>
                              <div style={{width: '45%'}}>
                                  <label>{prescription.presName} Refill :</label>
                                  <input
                                      className="input-field input-border"
                                      type="number"
                                      value={/* 0 refills is normal; `0 || ''` blanked the box */ prescription.refillCount ?? ''}
                                      onChange={(e) => handleRefillChange(prescription.type.presTypeId, prescription, e.target.value)} //presType.toLowerCase()
                                      placeholder="Enter Quantity..."
                                      style={{ width: '100%' }}
                                      onInput={(e) => handleInputChange(e)}
                                      min="0"
                                      step="1"
                                  />
                              </div>
                            </div>
                        ))}
                    </div>
                    <hr style={{marginTop: '20px'}}></hr>
                </>
            );
        })}
        {dosageMessage && <p style={{ color: 'red' }}>{dosageMessage}</p>}
        
        <button type="button" className='btn-filled' style={{padding: '10px 15px'}} onClick={handleSubmitDosage}>Submit</button>
    </div>
</Popup>


</div>}
    
   <Loader active={isLoading} />
   </div>
  );
};

export default Orders;
